import React, { useState, useEffect } from "react";
import Section from "../components/Section";
import Skill from "../components/Skill";
import Pie3D from "../components/Chart/Pie3D";
import {
  SiAndroidstudio,
  SiCss3,
  SiFirebase,
  SiDjango,
  SiFlask,
  SiGit,
  SiGithub,
  SiGitlab,
  SiHtml5,
  SiIntellijidea,
  SiJavascript,
  SiJupyter,
  SiMysql,
  SiMongodb,
  SiPostgresql,
  SiPostman,
  SiPython,
  SiReact,
  SiTensorflow,
  SiVisualstudiocode,
} from "react-icons/si";
import { TbBrandNextjs,TbBrandVue } from "react-icons/tb";
import { BsTerminalFill } from "react-icons/bs";
import { DiJava } from "react-icons/di";

const Skills = () => {
  const [repoItems, setRepoItems] = useState([]);
  const [dataSource, setDataSource] = useState([]);

  let data = {
    skills: [
      {
        title: "C / C++",
        progress: "85%",
      },
      {
        title: "Java",
        progress: "50%",
      },
      {
        title: "Javascript",
        progress: "80%",
      },
      {
        title: "Python",
        progress: "75%",
      },
      {
        title: "HTML",
        progress: "88%",
      },
      {
        title: "CSS",
        progress: "84%",
      },
    ],
    frameworks: [
      {
        title: "React.js",
        progress: "90%",
      },
      {
        title: "Redux",
        progress: "80%",
      },
      {
        title: "NodeJS",
        progress: "75%",
      },
      {
        title: "NextJs",
        progress: "85%",
      },
      {
        title: "Flask",
        progress: "45%",
      },
      {
        title: "Django",
        progress: "55%",
      },
      {
        title: "Bootstrap",
        progress: "70%",
      },
      {
        title: "Material-UI",
        progress: "60%",
      },
      {
        title: "Tailwind CSS",
        progress: "90%",
      },
    ],
  };

  const getData = () => {
    fetch("https://api.github.com/users/PrashantS360/repos?per_page=100")
      .then((res) => res.json())
      .then((data) => setRepoItems(data));
  };

  useEffect(() => {
    // Fetch from official api
    getData();

    // Offline api
    // setRepoItems(items)
  }, []);

  useEffect(() => {
    let languages = repoItems.reduce((total, item) => {
      const { language, stargazers_count } = item;
      if (!language) return total;

      if (!total[language]) {
        total[language] = {
          label: language,
          value: 1,
          stars: stargazers_count,
        };
      } else {
        total[language] = {
          ...total[language],
          value: total[language].value + 1,
          stars: total[language].stars + 1,
        };
      }

      return total;
    }, {});

    const mostUsed = Object.values(languages)
      .sort((a, b) => {
        return b.value - a.value;
      })
      .slice(0, 5);
    setDataSource(mostUsed);
  }, [repoItems]);

  const { skills, frameworks } = data;

  const skillsJsx = skills.map((skill, index) => (
    <div className="col-md-8 py-1" key={index}>
      <Skill skill={skill} />
    </div>
  ));

  const frameworksJsx = frameworks.map((skill, index) => (
    <div className="col-md-8 py-1" key={index}>
      <Skill skill={skill} secondary />
    </div>
  ));

  const languagesUsedChart = (
    <div className="col-md-6 py-1">
      <Pie3D data={dataSource} />
    </div>
  );

  const SocialIcon = ({ icon }) => {
    return (
      <div
        className="list-inline-item dev-icons"
        target="_blank"
        rel="noopener noreferrer"
      >
        {icon}
      </div>
    );
  };

  const iconsSet1 = [
    {
      icon: <SiGit />,
    },
    {
      icon: <SiGithub />,
    },
    {
      icon: <SiGitlab />,
    },
  ];

  const iconsSet2 = [
    {
      icon: <DiJava />,
    },
    {
      icon: <SiPython />,
    },
    {
      icon: <SiJavascript />,
    },
  ];

  const iconsSet3 = [
    {
      icon: <SiTensorflow />,
    },
    {
      icon: <SiFlask />,
    },
    {
      icon: <SiDjango />,
    },
  ];

  const iconsSet4 = [
    {
      icon: <SiHtml5 />,
    },
    {
      icon: <SiCss3 />,
    },
    {
      icon: <SiReact />,
    },
    {
      icon: <TbBrandNextjs />,
    },
    {
      icon: <TbBrandVue />,
    },
  ];

  const iconsSet5 = [
    {
      icon: <SiMongodb />,
    },
    {
      icon: <SiPostgresql />,
    },
    {
      icon: <SiFirebase />,
    },
    {
      icon: <SiMysql />,
    },
  ];

  const iconsSet6 = [
    {
      icon: <SiVisualstudiocode />,
    },
    {
      icon: <SiJupyter />,
    },
    {
      icon: <SiIntellijidea />,
    },
    {
      icon: <SiAndroidstudio />,
    },
    {
      icon: <SiPostman />,
    },
    {
      icon: <BsTerminalFill />,
    },
  ];

  return (
    <Section id="skills" title="Skills">
      <div className="subheading mb-3">Coding Languages</div>
      <div className="row mb-4">{skillsJsx}</div>
      <div className="subheading mb-3">Frameworks / Libraries</div>
      <div className="row mb-4">{frameworksJsx}</div>
      <div className="subheading mb-3">Languages used as per Github</div>
      <div className="row mb-4">{languagesUsedChart}</div>
      <div className="subheading mb-3">
        Programming Languages, Tools & Technologies
      </div>
      <div>
        {iconsSet1.map(({ icon }, index) => (
          <SocialIcon icon={icon} key={index} />
        ))}
      </div>
      <div>
        {iconsSet2.map(({ icon }, index) => (
          <SocialIcon icon={icon} key={index} />
        ))}
      </div>
      <div>
        {iconsSet3.map(({ icon }, index) => (
          <SocialIcon icon={icon} key={index} />
        ))}
      </div>
      <div>
        {iconsSet4.map(({ icon }, index) => (
          <SocialIcon icon={icon} key={index} />
        ))}
      </div>
      <div>
        {iconsSet5.map(({ icon }, index) => (
          <SocialIcon icon={icon} key={index} />
        ))}
      </div>
      <div>
        {iconsSet6.map(({ icon }, index) => (
          <SocialIcon icon={icon} key={index} />
        ))}
      </div>
    </Section>
  );
};

export default Skills;
